export const MentalDiscomfortLevelEnum = Object.freeze({
    None: "NO",
    Little: "LITTLE",
    Moderate: "MODERATE",
    Severe: "SEVERE",
    Extreme: "EXTREME"
})
